import undergraduateRouter from './undergraduate'
const routers = [
  // 视频
  {
    path: '/video',
    name: 'video',
    component: () => import('@/components/video/video')
  },
  // 登陆
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/into/login')
  },
  // 忘记密码
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/view/into/forget-pwd1')
  },
  {
    path: '/modify',
    name: 'modify',
    component: () => import('@/view/into/forget-pwd2')
  },
  {
    path: '/',
    name: 'home',
    redirect: '/index',
    component: () => import('@/view/home'),
    children: [
      {
        path: 'index',
        name: 'home-index',
        component: () => import('@/view/home/home-main')
      },
      // 我的规划
      {
        path: 'myplan',
        name: 'myplan',
        redirect: {
          name: 'myplan-main'
        },
        component: () => import('@/view/myplan/main'),
        children: [
          {
            path: 'index',
            name: 'myplan-main',
            redirect: {
              name: 'myplan-todo-tabs'
            },
            component: () => import('@/view/myplan/myplan'),
            children: [
              {
                path: 'todo',
                name: 'myplan-todo-tabs',
                component: () => import('@/view/myplan/components/myplan-todo')
              },
              {
                path: 'overview',
                name: 'myplan-overview-tabs',
                component: () => import('@/view/myplan/components/myplan-management')
              }
            ]
          },
          // 预约导师
          {
            path: 'history',
            name: 'myplan-history',
            component: () => import('@/view/myplan/myplan-history')
          }
        ]
      },
      //  申请信息
      {
        path: 'application',
        name: 'application',
        redirect: {
          name: 'application-education'
        },
        component: () => import('@/view/application-info/main.vue'),
        children: [
          // 教育背景
          {
            path: 'education',
            name: 'application-education',
            component: () => import('@/view/application-info/education')
          },
          // 考试分数
          {
            path: 'score',
            name: 'application-exam-score',
            component: () => import('@/view/application-info/exam-score')
          },
          // 个人经历
          {
            path: 'experience',
            name: 'application-experience',
            component: () => import('@/view/application-info/experience')
          },
          // 申请意向
          {
            path: 'intention',
            name: 'application-intention',
            component: () => import('@/view/application-info/intention')
          },
          // 申请意向
          {
            path: 'project',
            name: 'application-project',
            component: () => import('@/view/application-info/project')
          },
          // 研究方向
          {
            path: 'research-direction',
            name: 'application-research-direction',
            component: () =>
              import('@/view/application-info/research-direction')
          },
          // 科研经历
          {
            path: 'research-exp',
            name: 'application-research-exp',
            component: () => import('@/view/application-info/research-exp')
          },
          // 实习经历
          {
            path: 'practice',
            name: 'application-practice',
            component: () => import('@/view/application-info/practice')
          },
          // 课外活动
          {
            path: 'extracurricular',
            name: 'application-extracurricular',
            component: () => import('@/view/application-info/extracurricular')
          },
          // 家庭信息
          {
            path: 'family',
            name: 'application-family',
            component: () => import('@/view/application-info/family')
          },
           // 上传信息搜集表
           {
            path: 'upload-info',
            name: 'application-upload-info',
            component: () => import('@/view/application-info/upload-info')
          }
        ]
      },
      // 服务团队
      {
        path: 'team',
        name: 'team',
        component: () => import('@/view/team/team')
      },
      // 导师辅导
      {
        path: 'mentor',
        name: 'mentor',
        redirect: {
          name: 'mentor-application-record'
        },
        component: () => import('@/view/mentor/main'),
        children: [
          // 导师辅导首页
          {
            path: 'record',
            name: 'mentor-application-record',
            component: () => import('@/view/mentor/application-record')
          },
          // 预约导师
          {
            path: 'application',
            name: 'mentor-application-mentor',
            component: () => import('@/view/mentor/application-mentor')
          },
          // ZOOM页面
          {
            path: 'zoom',
            name: 'mentor-zoom',
            component: () => import('@/view/mentor/zoom')
          }
        ]
      },
      // 项目选择
      {
        path: 'choose',
        name: 'project-choose',
        component: () => import('@/view/project/choose'),
        redirect: {
          name: 'project-choose-preview-list'
        },
        children: [
          {
            path: 'list',
            name: 'project-choose-list',
            redirect: {
              name: 'project-choose-preview-list'
            },
            component: () => import('@/view/project/choose/choose-list'),
            children: [
              {
                path: 'preview-list',
                name: 'project-choose-preview-list',
                component: () => import('@/view/project/choose/preview-list')
              },
              {
                path: 'scheme-list',
                name: 'project-choose-scheme-list',
                component: () => import('@/view/project/choose/scheme-list')
              },
              {
                path: 'agree-list',
                name: 'project-choose-agree-list',
                component: () => import('@/view/project/choose/agree-list')
              }
            ]
          },
          {
            path: 'preview',
            name: 'project-choose-preview',
            component: () => import('@/view/project/choose/preview-detail')
          },
          {
            path: 'scheme',
            name: 'project-choose-scheme',
            component: () => import('@/view/project/choose/scheme-detail')
          },
          {
            path: 'agree',
            name: 'project-choose-agree',
            component: () => import('@/view/project/choose/agree-detail')
          }
        ]
      },
      // 项目申请
      {
        path: 'project',
        name: 'project',
        redirect: {
          name: 'project-coach'
        },
        component: () => import('@/view/project/main'),
        children: [
          // 项目申请首页
          {
            path: 'coach',
            name: 'project-coach',
            component: () => import('@/view/project/coach')
          },
          // 项目申请信息
          {
            path: 'info/:id/:type',
            name: 'project-coach-info',
            component: () => import('@/view/project/coach-info'),
            children: [
              // 文书信息
              {
                path: 'essay-info',
                name: 'project-essay-info',
                redirect: {
                  name: 'project-essay-info-detail'
                },
                component: () => import('@/view/project/essay-info'),
                children: [
                  // 文书信息详情
                  {
                    path: 'detail',
                    name: 'project-essay-info-detail',
                    component: () =>
                      import('@/view/project/components/essay-info-detail')
                  },
                  // 文书信息添加
                  {
                    path: 'fill',
                    name: 'project-essay-info-fill',
                    component: () =>
                      import('@/view/project/components/essay-info-fill')
                  },
                  // 文书信息修改
                  {
                    path: 'dit',
                    name: 'project-essay-info-edit',
                    component: () =>
                      import('@/view/project/components/essay-info-edit')
                  }
                ]
              },
              // 专家修改
              {
                path: 'expert-modify',
                name: 'project-expert-modify',
                component: () => import('@/view/project/expert-modify')
              },
              // 文书修改
              {
                path: 'essay-modify',
                name: 'project-essay-modify',
                component: () => import('@/view/project/essay-modify')
              },
              // 面试相关
              {
                path: 'interview',
                name: 'project-interview',
                component: () => import('@/view/project/interview')
              },
              // 面试相关-面试经历
              {
                path: 'interview-exp',
                name: 'project-interview-exp',
                component: () => import('@/view/project/interview-exp')
              },
              // 面试相关-申请导师
              {
                path: 'interview-mentor',
                name: 'project-interview-mentor',
                component: () => import('@/view/project/interview-mentor')
              },
              // 面试相关- 预约详情
              {
                path: 'interview-zoom',
                name: 'project-interview-zoom',
                component: () => import('@/view/project/zoom')
              },
              // 申请情况
              {
                path: 'application',
                name: 'project-application-status',
                component: () => import('@/view/project/application-status')
              }
            ]
          }
        ]
      },
      // 简历/推荐信
      {
        path: 'cv-rl',
        name: 'cv-rl-main',
        redirect: {
          name: 'cv-rl'
        },
        component: () => import('@/view/CV-RL/main'),
        children: [
          // 简历/推荐信-首页
          {
            path: 'index',
            name: 'cv-rl',
            component: () => import('@/view/CV-RL/cv-rl')
          },
          // 简历/推荐信-cv
          {
            path: 'cv/:cvId',
            name: 'cv-rl-cv',
            component: () => import('@/view/CV-RL/cv-detail'),
            children: [
              {
                path: 'expert',
                name: 'cv-rl-cv-expert',
                component: () => import('@/view/CV-RL/cv-expert-modify')
              },
              // 简历/推荐信-详情
              {
                path: 'mentor',
                name: 'cv-rl-cv-mentor',
                component: () => import('@/view/CV-RL/cv-mentor-modify')
              }
            ]
          },
          // 简历/推荐信-rl
          {
            path: 'rl/:rlId',
            name: 'cv-rl-rl',
            component: () => import('@/view/CV-RL/rl-detail'),
            children: [
              {
                path: 'expert',
                name: 'cv-rl-rl-expert',
                component: () => import('@/view/CV-RL/rl-expert-modify')
              },
              // 简历/推荐信-详情
              {
                path: 'mentor',
                name: 'cv-rl-rl-mentor',
                component: () => import('@/view/CV-RL/rl-mentor-modify')
              }
            ]
          }
        ]
      },
      // 个人页面
      {
        path: '/personal',
        name: 'personal',
        redirect: {
          name: 'personal-own'
        },
        component: () => import('@/view/personal/main'),
        children: [
          // 消息页面
          {
            path: 'message',
            name: 'personal-message',
            component: () => import('@/view/personal/message')
          },
          // 个人资料
          {
            path: 'own',
            name: 'personal-own',
            component: () => import('@/view/personal/own')
          },
          // 套餐信息
          {
            path: 'package',
            name: 'personal-package',
            component: () => import('@/view/personal/package-info')
          },
          // 修改密码
          {
            path: 'modify',
            name: 'personal-modify-pwd',
            component: () => import('@/view/personal/modify-pwd')
          }
        ]
      },
      //  最新动态
      {
        path: '/news',
        name: 'other-news',
        component: () => import('@/view/other/news')
      },
      // 火炬计划
      {
        path: '/torch',
        name: 'other-torch',
        component: () => import('@/view/other/torch')
      },
      // 绑定微信
      {
        path: '/wx',
        name: 'other-bind-wx',
        component: () => import('@/view/other/bind-wx')
      },
      // 问题反馈
      {
        path: '/feedback',
        name: 'other-feedback',
        component: () => import('@/view/other/feedback')
      },
      // 须知文档
      {
        path: '/documents',
        name: 'documents',
        component: () => import('@/view/documents'),
        redirect: {
          name: 'documents-manual'
        },
        children: [
          {
            path: 'manual',
            name: 'documents-manual',
            component: () => import('@/view/documents/manual')
          }
        ]
      },
      {
        path: '/video-course',
        name: 'video-course',
        component: () => import('@/view/video-course')
      },
    ]
  },
  ...undergraduateRouter,
  {
    path: '/c',
    name: 'c',
    component: () => import('@/view/c')
  },
  {
    path: '*',
    name: '*',
    component: () => import('@/view/error-page/404')
  }
]
export default routers
